import { useMemo } from "react";
import HyroxMetadataContext from "./contexts/HyroxMetadataContext";
import { ScoreMetadata } from "types";
import { useTranslation } from "react-i18next";

interface HyroxMetadataProviderProps {
  children?: React.ReactNode;
}

function HyroxMetadataProvider(props: HyroxMetadataProviderProps) {
  const { t } = useTranslation();

  const hyroxConditioningScoreName = t("score_name_HYROX_CONDITIONING_SCORE");

  const hyroxMetadata = useMemo<ScoreMetadata[]>(() => {
    return [
      {
        id: "hyroxConditioning",
        field: "hyroxConditioning",
        name: hyroxConditioningScoreName,
        isEnabled: true,
        isPbEnabled: true,
        unitOfMeasure: "score",
        sortType: 1,
        displayMetadata: {
          imperial: { decimals: 0, unit: "Display Score" },
          metric: { decimals: 0, unit: "Display Score" },
        },
      },
    ];
  }, [hyroxConditioningScoreName]);

  return <HyroxMetadataContext.Provider value={hyroxMetadata}>{props.children}</HyroxMetadataContext.Provider>;
}

export default HyroxMetadataProvider;
